const ACTIVITY_KEY = 'poeLastActivity'
const IDLE_MS = 15 * 60 * 1000
const WARN_MS = 2 * 60 * 1000
const TOUCH_THROTTLE_MS = 1000

let lastTouchWrite = 0
let loggingOut = false

function officerTokenKey() {
  return 'token'
}

export function isOfficerSession() {
  return !!(localStorage.getItem('userData') && localStorage.getItem(officerTokenKey()))
}

export function touchActivity(force) {
  if (!isOfficerSession()) {
    return
  }
  const now = Date.now()
  if (!force && now - lastTouchWrite < TOUCH_THROTTLE_MS) {
    return
  }
  lastTouchWrite = now
  localStorage.setItem(ACTIVITY_KEY, String(now))
}

export function idleElapsedMs() {
  const last = Number(localStorage.getItem(ACTIVITY_KEY) || 0)
  if (!last) {
    return 0
  }
  return Date.now() - last
}

export function remainingMs() {
  return Math.max(0, IDLE_MS - idleElapsedMs())
}

export function isIdleExpired() {
  if (!isOfficerSession()) {
    return false
  }
  const last = Number(localStorage.getItem(ACTIVITY_KEY) || 0)
  if (!last) {
    touchActivity(true)
    return false
  }
  return idleElapsedMs() >= IDLE_MS
}

export function isIdleWarning() {
  if (!isOfficerSession() || isIdleExpired()) {
    return false
  }
  return remainingMs() <= WARN_MS
}

export function clearOfficerSession() {
  localStorage.removeItem('token')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('userData')
  localStorage.removeItem(ACTIVITY_KEY)
}

export function requestIdleLogout() {
  if (loggingOut) {
    return
  }
  loggingOut = true
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('poe-idle-logout'))
  }
}

export function resetLogoutGuard() {
  loggingOut = false
}

export const SESSION = {
  ACTIVITY_KEY,
  IDLE_MS,
  WARN_MS,
}
